import Papa from 'papaparse';

const emptyValue = function(value, callback, field) {
  if (value.length > 0) {
    return callback(true);
  } else {
    alert(field + ' is a required field');
    return callback(false);
  }
};

const to_csv = function(workbook,type) {
  const result = [];
  workbook.SheetNames.forEach(function(sheetName) {
    let csv = [];
    switch (type) {
      case 'xls':
        csv = XLS.utils.sheet_to_csv(workbook.Sheets[sheetName]);
        break;
      case 'xlsx':
        csv = XLSX.utils.sheet_to_csv(workbook.Sheets[sheetName]);
        break;
    }
    if (csv.length > 0) {
      return result.push(csv);
    }

  });
  return result.join("\n");
};


const read_workbook = function(workbook) {
  const result = [];
  workbook.SheetNames.forEach(function(sheetName) {
    const sheet = workbook.Sheets[sheetName];
    if (!!sheet['!ref']) {
      const ref = sheet['!ref'].split(":");
      const name_identifier = ref[0].match(/[A-Z]*/)[0];
      const description_identifier = ref[1].match(/[A-Z]*/)[0];
      let range_start = parseInt(ref[0].match(/[0-9]*$/)[0]);
      const range_end = parseInt(ref[1].match(/[0-9]*$/)[0]);
      return (() => {
        const result1 = [];
        while (range_start <= range_end) {
          if (!!sheet[`${name_identifier}${range_start}`] && !!sheet[`${description_identifier}${range_start}`]) {
            result.push({name: sheet[`${name_identifier}${range_start}`].v, description: sheet[`${description_identifier}${range_start}`].v});
          }
          result1.push(range_start = range_start + 1);
        }
        return result1;
      })();
    }
  });
  return result;
};

$("#knowledge-items-import-form").submit(function(e) {
  e.preventDefault();
  $("#start-import-button").val("Please Wait ..");
  $("#start-import-button").attr('disable',true);
  $("#start-import-button").css('pointer-events',"none");
  $("#clear-import-data-button").hide();
  $(".items").empty();
  return $.post(`${$(this).attr('action')}.js`,$(this).serialize()).success(function(data,textStatus,jqXHR) {
    $("#start-import-button").attr('disable',false);
    $("#start-import-button").css('pointer-events',"all");
    $("#start-import-button").val("Start Import");
    $("#clear-import-data-button").hide();
    return $("#knowledge-items-import-form")[0].reset();
  });
});

$("#clear-knowledge-import-data-button").click(function(e) {
  e.preventDefault();
  if (confirm("Are you sure you want to clear loaded data?")) {
    return location.reload();
  }
});

$('#knowledge_items_import_type').change(function(e) {
  if (($('#knowledge_items_import_type').val() === "Translate existing") || ($('#knowledge_items_import_type').val() === "Update existing")) {
    return $('#knowledge-items-select-category').hide();
  } else {
    return $('#knowledge-items-select-category').show();
  }
});

$("#knowledge_items_to_import").change(function(e) {
  let add_list = null;
  let file = null;
  let reader = null;
  add_list = $(this);
  file = $(this)[0].files[0];
  const colHeaders = ['Name', 'Description'];
  if (file) {
    reader = new FileReader();
    let file_type = null;
    const file_name_parts = file.name.split(".");
    if (file_name_parts[file_name_parts.length - 1] === "csv") {
      reader.readAsText(file);
      file_type = 'csv';
    } else {
      if (file_name_parts[file_name_parts.length - 1] === "xlsx") {
        reader.readAsArrayBuffer(file);
        file_type = "xlsx";
      } else {
        if (file_name_parts[file_name_parts.length - 1] === "xls") {
          reader.readAsArrayBuffer(file);
          file_type = "xls";
        }
      }
    }

    if (!!!file_type) {
      alert("Please select a CSV or Excel (xlsx) file.");
      e.preventDefault();
      $(this).val("");
      return;
    } else {
      $("input[type='submit']").show();
      $("#clear-knowledge-import-data-button").show();
    }

    reader.onload = function(ee) {
      let imported_words_data = [];
      let binary, bytes, length, i, temp1;

      switch (file_type) {
        case 'csv':
          let words_data = Papa.parse(ee.target.result, {}).data;
          for (let word of Array.from(words_data)) {
            if (!!word[0] && !!word[1]) {
              imported_words_data.push({
                name: word[0],
                description: word[1]
              });
            }
          }
          break;
        case 'xlsx':
          binary = "";
          bytes = new Uint8Array(ee.target.result);
          length = bytes.byteLength;
          i = 0;
          while (i < length) {
            binary += String.fromCharCode(bytes[i]);
            i = i + 1;
          }

          temp1 = XLSX.read(binary, {type: 'binary'});
          imported_words_data = read_workbook(temp1);
          break;
        case 'xls':
          binary = "";
          bytes = new Uint8Array(ee.target.result);
          length = bytes.byteLength;
          i = 0;
          while (i < length) {
            binary += String.fromCharCode(bytes[i]);
            i = i + 1;
          }
          temp1 = XLS.parse_xlscfb(XLS.CFB.read(binary, {type: 'binary'}));
          imported_words_data = read_workbook(temp1);
          break;
        default:
          alert("Please use either Excel or CSV file");
          return;
      }


      return $('#items').val(JSON.stringify(imported_words_data));
    };
  }
});